import { styles, mobileStyles } from "./Style.js"
import { useIsMobile } from "./useIsMobile.js"
import { SetBoard } from "./Set/SetBoard"
import { getMatch, getDeck } from "./Set/SetCalc.js"
import { useEffect, useState } from "react"

export function SetGame(props) {
    const isMobile = useIsMobile()
    const [deck, setDeck] = useState([])
    const [selected, setSelected] = useState([-1, -1, -1])
    const [board, setBoard] = useState([])
    const [score, setScore] = useState(0)

    // Deal the opening board once, on mount
    useEffect(() => {
        const d = getDeck()
        const b = []
        for (let i = 0; i < 20; i++) {
            b.push(d.splice(Math.floor(Math.random() * d.length), 1)[0])
        }
        setDeck(d)
        setBoard(b)
    }, [])

    const click = (pos) => {
        if (board[pos] === -1) return // ignore empty slots

        let ms = [...selected]
        let s
        if ((s = ms.indexOf(pos)) > -1) {
            ms[s] = -1                 // clicking a selected card deselects it
        } else {
            ms[ms.indexOf(-1)] = pos   // otherwise select into the first free slot
        }

        if (ms.indexOf(-1) === -1) {
            // Three cards picked - is it a valid set?
            if (getMatch(board[ms[0]], board[ms[1]]) === board[ms[2]]) {
                const b = [...board]
                const d = [...deck]
                ms.forEach((p) => {
                    b[p] = d.length === 0 ? -1 : d.splice(Math.floor(Math.random() * d.length), 1)[0]
                })
                setBoard(b)
                setDeck(d)
                setScore((sc) => sc + 1)
            } else {
                alert("No set!")
                setScore((sc) => (sc > 0 ? sc - 1 : 0))
            }
            ms = [-1, -1, -1]
        }

        setSelected(ms)
    }

    return (
        <div style={isMobile ? {...styles.SetGame, ...mobileStyles.SetGame} : styles.SetGame}>
            <SetBoard click={click} selected={selected} board={board} isMobile={isMobile} />
            <div style={isMobile ? {...styles.setSide, ...mobileStyles.setSide} : styles.setSide}>
                <p>
                    Match all-similar or all-different cards in each category:
                    <br />Number<br />Color<br />Shape<br />Shade
                </p>
                <br />
                <h2>Score: {score}</h2>
            </div>
        </div>
    )
}
